import { SvgIconProps, Tooltip } from '@mui/material';
import { ReactNode, useEffect, useState } from 'react';
import { Copy } from 'react-feather';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import IconFeather from 'src/components/common/Icon';

const CopyText = ({
  text = '',
  icon = <Copy />,
  muiProps = {},
}: {
  text?: string;
  icon?: ReactNode;
  muiProps?: SvgIconProps;
}) => {
  const [tooltip, setTooltip] = useState('Copy');
  const [visible, setVisible] = useState(false);

  const handleClick = () => {
    setTooltip('Copied');
    navigator.clipboard.writeText(text);
  };

  useEffect(() => {
    if (!visible) {
      setTooltip('Copy');
    }
  }, [visible]);

  return (
    <Tooltip arrow onClose={() => setVisible(false)} onOpen={() => setVisible(true)} open={visible} title={tooltip}>
      <ButtonWithLoading onClick={handleClick} color="inherit">
        <IconFeather muiProps={{ fontSize: 'small', ...muiProps }} icon={icon} />
      </ButtonWithLoading>
    </Tooltip>
  );
};

export default CopyText;
